import { useEffect, useState } from "react";
import "./LoaderV2.scss";
import PropTypes from "prop-types";

const LoaderV2 = ({ id, loaderSize }) => {
  const [loaderSizeValue, setLoaderSizeValue] = useState("");
  const [containerSizeValue, setContainerSizeValue] = useState("");
  useEffect(() => {
    switch (loaderSize) {
      case "small-loader":
        setLoaderSizeValue("small-loader");
        setContainerSizeValue("small-loader-container");
        break;
      case "fullpage":
        setLoaderSizeValue("loaderV2-fullpage-spinner");
        setContainerSizeValue("loaderV2-fullpage");
        break;
      default:
        setLoaderSizeValue("loaderV2");
        setContainerSizeValue("loaderV2-container");
        break;
    }
  }, [loaderSize]);

  if (loaderSize === "fullpage") {
    return (
      <div className="loaderV2-fullpage" id={id}>
        <div className="loaderV2-fullpage-spinner"></div>
        <span className="loaderV2-fullpage-text">Chargement...</span>
      </div>
    );
  }

  return (
    <div className={`${containerSizeValue}`} id={id}>
      <div className={`${loaderSizeValue}`}></div>
    </div>
  );
};

LoaderV2.propTypes = {
  id: PropTypes.string,
  loaderSize: PropTypes.string,
};

export default LoaderV2;
